/*
 * Organization Actions
 */

export const ORG_REQUEST = 'ORG_REQUEST'
export const ORG_ERROR = 'ORG_ERROR'

export const ORG_SET_USER_ORGS = 'ORG_SET_USER_ORGS'
export const ORG_SET_ALL_ORGS = 'ORG_SET_ALL_ORGS'
